import { Gallery as IGallery } from '../../models/course/ICourseContent';
import { ISidebarNavigation } from '../../models/sidebar-navigation/ISidebarNavigation';
import { MediaAssetType } from '../../constants/media-asset-type';

function hasMediaGalleryVisible(mediaGallery: IGallery, showMediaAsset: string): boolean {
  const hasGallery = Boolean(mediaGallery?.fields?.gallery);
  return (
    hasGallery &&
    (showMediaAsset === MediaAssetType.MediaGallery || showMediaAsset === MediaAssetType.Both)
  );
}

function buildOverviewAndKeyInfoLinks(
  translate: any,
  keyInformation: string,
): ISidebarNavigation['links'] {
  const links: ISidebarNavigation['links'] = [
    {
      fields: {
        displayName: translate('Courses.overview'),
        urlLink: '#overview',
        application: 'Both',
      },
    },
  ];

  if (keyInformation) {
    links.push({
      fields: {
        displayName: translate('Courses.keyInformation'),
        urlLink: '#key-information',
        application: 'Both',
      },
    });
  }

  return links;
}

function buildMediaGalleryLinks(
  translate: any,
  mediaGallery: IGallery,
  showMediaAsset: string,
  isBrandUS: boolean,
): ISidebarNavigation['links'] {
  if (!hasMediaGalleryVisible(mediaGallery, showMediaAsset)) return [];
  return [
    {
      fields: {
        displayName: isBrandUS
          ? translate('Courses.moreAboutThisProgram')
          : translate('Courses.moreAboutThisCourse'),
        urlLink: '#media-gallery-section',
        application: 'Both',
      },
    },
  ];
}

export function getCourseSidebarNavs(
  translate: any,
  keyInformation: string,
  showMediaAsset: string,
  mediaGallery: IGallery,
  isBrandUS: boolean,
): ISidebarNavigation {
  const courseDetailsLabel = isBrandUS
    ? translate('Courses.programDetails')
    : translate('Courses.courseDetails');

  const links: ISidebarNavigation['links'] = [
    ...buildOverviewAndKeyInfoLinks(translate, keyInformation),
    {
      fields: {
        displayName: courseDetailsLabel,
        urlLink: '#course-details',
        application: 'Both',
      },
    },
    ...buildMediaGalleryLinks(translate, mediaGallery, showMediaAsset, isBrandUS),
  ];

  return { links };
}
export function getSummarySidebarNavs(
  translate: any,
  keyInformation: string,
  showMediaAsset: string,
  mediaGallery: IGallery,
  isBrandUS: boolean,
): ISidebarNavigation {
  const links: ISidebarNavigation['links'] = [
    ...buildOverviewAndKeyInfoLinks(translate, keyInformation),
    ...buildMediaGalleryLinks(translate, mediaGallery, showMediaAsset, isBrandUS),
    {
      fields: {
        displayName: translate('Courses.degrees'),
        urlLink: '#degree-summary',
        application: 'Both',
      },
    },
  ];

  return { links };
}
